export default "__VITE_ASSET__DU3mF3JY__"